import { createActions } from "redux-actions"


export enum GenrateNewExperimentsActionTypes {
  REQUEST = "GENERATE_EXPERIMENT_REQUEST",
  SUCCESS = "GENERATE_EXPERIMENT_SUCCESS",
  FAILURE = "GENERATE_EXPERIMENT_FAILURE"
}

export enum ListAlgorithmsActionTypes {
  REQUEST = "LIST_ALGORITHMS_REQUEST",
  SUCCESS = "LIST_ALGORITHMS_SUCCESS",
  FAILURE = "LIST_ALGORITHMS_FAILURE"
}

export enum UploadDoeExperimentsActionTypes {
  REQUEST = "UPLOAD_DOE_REQUEST",
  SUCCESS = "UPLOAD_DOE_SUCCESS",
  FAILURE = "UPLOAD_DOE_FAILURE",
  CLEANUP = "UPLOAD_DOE_CLEAR"
}

export enum DoeHistoryListActionTypes {
  REQUEST = "DOE_HISTORY_LIST_REQUEST",
  SUCCESS = "DOE_HISTORY_LIST_SUCCESS",
  FAILURE = "DOE_HISTORY_LIST_FAILURE"
}

export enum GetDoeExperimentsActionTypes {
  REQUEST = "GET_DOE_EXPERIMENTS_REQUEST",
  SUCCESS = "GET_DOE_EXPERIMENTS_SUCCESS",
  FAILURE = "GET_DOE_EXPERIMENTS_FAILURE"
}

export enum DeleteDoeActionTypes {
  REQUEST = "DELETE_DOE_REQUEST",
  SUCCESS = "DELETE_DOE_SUCCESS",
  FAILURE = "DELETE_DOE_FAILURE",
  CLEANUP = "DELETE_DOE_CLEANUP"
}

export enum EditDoeActionTypes {
  REQUEST = "EDIT_DOE_REQUEST",
  SUCCESS = "EDIT_DOE_SUCCESS",
  FAILURE = "EDIT_DOE_FAILURE"
}

export enum OtherLocalStuff {
  SELECT_ALGO = "SELECT_ALGO",
  SET_FORM_DATA = "SET_FORM_DATA",
  SET_ADDITIONAL_PARAMS = "SET_ADDITIONAL_PARAMS",
  SET_INGREDIENTS_FACTORS = "SET_INGREDIENTS_FACTORS",
  SET_INGREDIENTS_CONSTANTS = "SET_INGREDIENTS_CONSTANTS",
  SET_PROCESSING_FACTORS = "SET_PROCESSING_FACTORS",
  SET_PROCESSING_CONSTANTS = "SET_PROCESSING_CONSTANTS",
  SET_PARAMS_CHECK = "SET_PARAMS_CHECK",
  SET_FACTORS_CHECK = "SET_FACTORS_CHECK",
  SET_FACTORS_MODAL_CHECK = "SET_FACTORS_MODAL_CHECK",
  SET_TAGUCHI_SELECTED_LEVEL = "SET_TAGUCHI_SELECTED_LEVEL",
  CLEAR_OTHER_STUFF = "CLEAR_OTHER_STUFF"
}


export const {
  generateExperimentRequest,
  generateExperimentSuccess,
  generateExperimentFailure,
  listAlgorithmsRequest,
  listAlgorithmsSuccess,
  listAlgorithmsFailure,
  uploadDoeRequest,
  uploadDoeSuccess,
  uploadDoeFailure,
  uploadDoeClear,
  doeHistoryListRequest,
  doeHistoryListSuccess,
  doeHistoryListFailure,
  getDoeExperimentsRequest,
  getDoeExperimentsSuccess,
  getDoeExperimentsFailure,
  deleteDoeCleanup,
  deleteDoeRequest,
  deleteDoeSuccess,
  deleteDoeFailure,
  editDoeRequest,
  editDoeSuccess,
  editDoeFailure,
  selectAlgo,
  setFormData,
  setAdditionalParams,
  setIngredientsFactors,
  setIngredientsConstants,
  setProcessingFactors,
  setProcessingConstants,
  setParamsCheck,
  setFactorsCheck,
  setFactorsModalCheck,
  setTaguchiSelectedLevel,
  clearOtherStuff
} = createActions({
  [GenrateNewExperimentsActionTypes.REQUEST]: payload => payload,
  [GenrateNewExperimentsActionTypes.SUCCESS]: resposne => resposne,
  [GenrateNewExperimentsActionTypes.FAILURE]: () => { },
  [ListAlgorithmsActionTypes.REQUEST]: payload => payload,
  [ListAlgorithmsActionTypes.SUCCESS]: resposne => resposne,
  [ListAlgorithmsActionTypes.FAILURE]: () => { },
  [UploadDoeExperimentsActionTypes.REQUEST]: payload => payload,
  [UploadDoeExperimentsActionTypes.SUCCESS]: resposne => resposne,
  [UploadDoeExperimentsActionTypes.FAILURE]: () => { },
  [UploadDoeExperimentsActionTypes.CLEANUP]: () => { },
  [DoeHistoryListActionTypes.REQUEST]: payload => payload,
  [DoeHistoryListActionTypes.SUCCESS]: resposne => resposne,
  [DoeHistoryListActionTypes.FAILURE]: () => { },
  [GetDoeExperimentsActionTypes.REQUEST]: payload => payload,
  [GetDoeExperimentsActionTypes.SUCCESS]: resposne => resposne,
  [GetDoeExperimentsActionTypes.FAILURE]: () => { },
  [DeleteDoeActionTypes.CLEANUP]: () => { },
  [DeleteDoeActionTypes.REQUEST]: payload => payload,
  [DeleteDoeActionTypes.SUCCESS]: resposne => resposne,
  [DeleteDoeActionTypes.FAILURE]: () => { },
  [EditDoeActionTypes.REQUEST]: payload => payload,
  [EditDoeActionTypes.SUCCESS]: resposne => resposne,
  [EditDoeActionTypes.FAILURE]: () => { },
  [OtherLocalStuff.SELECT_ALGO]: payload => payload,
  [OtherLocalStuff.SET_FORM_DATA]: payload => payload,
  [OtherLocalStuff.SET_ADDITIONAL_PARAMS]: payload => payload,
  [OtherLocalStuff.SET_INGREDIENTS_FACTORS]: payload => payload,
  [OtherLocalStuff.SET_INGREDIENTS_CONSTANTS]: payload => payload,
  [OtherLocalStuff.SET_PROCESSING_FACTORS]: payload => payload,
  [OtherLocalStuff.SET_PROCESSING_CONSTANTS]: payload => payload,
  [OtherLocalStuff.SET_PARAMS_CHECK]: payload => payload,
  [OtherLocalStuff.SET_FACTORS_CHECK]: payload => payload,
  [OtherLocalStuff.SET_FACTORS_MODAL_CHECK]: payload => payload,
  [OtherLocalStuff.SET_TAGUCHI_SELECTED_LEVEL]: payload => payload,
  [OtherLocalStuff.CLEAR_OTHER_STUFF]: () => { },
})
